import React, { Component } from "react";
import AdminVideos from "../Videos/Videos";

class AdminWorkflowVideos extends Component {
  render() {
    return <AdminVideos workflow {...this.props} />;
  }
}

export default AdminWorkflowVideos;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/WorkflowVideos/WorkflowVideos.js